import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IShowMoreBtnProps {
  text: string;
  onClick(): void;
}

export const OpenFullscreenBtn: React.FC<IShowMoreBtnProps> = ({ onClick, text }) => {
  return (
    <div className={styles['show-more']}>
      <button type="button" className={styles['show-more-btn']} onClick={() => onClick()}>
        <UIText1 color="text-main-default" display="inline">
          {text}
        </UIText1>
      </button>
    </div>
  );
};
